var Label_Anime = {
	init:function(){
		$('input, textarea').focus(function(){
			$(this).parent().addClass('focused');
		});

		$('input, textarea').blur(function(){
			var inputValue = $(this).val();
			if ( inputValue == "" ) {
				$(this).removeClass('filled');
				$(this).parent().removeClass('focused'); 
				$(this).parent().removeClass('focused'); 
			} else {
				$(this).addClass('filled');
			}
		});
		
		$('input, textarea').each(function(){
			
			if($(this).val() != ""){
				$(this).parent().addClass('focused');
			}
		});
	}
}

$(window).load(function(){
	if($("input, textarea").length){
		Label_Anime.init();
	}
})